import { CommonModule, NgFor } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { RouterModule } from '@angular/router';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { RatingModule } from 'primeng/rating';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-main-footer',
  standalone: true,
  imports: [NgFor,
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    RatingModule,
    FormsModule],
  templateUrl: './main-footer.component.html',
  styleUrl: './main-footer.component.scss'
})
export class MainFooterComponent implements OnInit {
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  protected icons = {
    faFacebook: faFacebook,
    faXTwitter: faXTwitter,
    faLinkedin: faLinkedin
  }

  linksRight: { label: string; url: string }[] = [];
  faStar = faStar;
  rating = 4.7;
  reviews = 115;
  stars = Array(5);

  linksLeft: { label: string; url: string }[] = [
    { label: 'Privacy Policy', url: 'https://www.frontstream.com/privacy-policy' },
    { label: 'Terms of Use', url: this.absoluteMediaUriService.getAbsoluteMediaUri('/docs/eula_buyer.pdf') },
    { label: 'Cookie Policy', url: 'https://www.frontstream.com/cookie-policy' },
    { label: 'Accessibility', url: 'https://www.frontstream.com/accessibility-statement' },
  ];

  contactUrl = this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/communicate/contactus.action');
  currentYear = new Date().getFullYear();

  copyright = {
    year: `2003-${this.currentYear}`,
    company: 'BiddingForGood.',
    message: 'All Rights Reserved',
  };

  linksSections = [
    {
      idSection: 1,
      label: 'Browse Live Auctions',
      url: '#',
      subLinks: [
        { label: 'All Auctions', url: '/auction-listing' },
        { label: 'Closing Soon', url: '/auction-listing?category=closing' },
        { label: 'Live Events', url: '/auction-listing?category=live' },
      ]
    },
    {
      idSection: 2,
      label: 'Raise More Funds',
      url: '#',
      subLinks: [
        { label: 'Run a BiddingForGood Auction', url: 'https://www.frontstream.com/auctions' },
        { label: 'Host a Peer-to-Peer event', url: 'https://www.frontstream.com/peer-to-peer' },
        { label: 'Manage Donor Data', url: 'https://www.frontstream.com/donation-campaigns' },
      ]
    },
    {
      idSection: 3,
      label: 'About Us',
      url: '#',
      subLinks: [
        { label: 'Our Story', url: 'https://www.frontstream.com/about' },
        { label: 'BiddingForGood FAQ', url: 'https://support.frontstream.com/hc/en-us/sections/115001633423-Bidder-FAQ' },
        { label: 'Tour FrontStream', url: 'https://www.frontstream.com/request-a-demo-panorama' },
      ]
    }
  ];


  constructor(private apiService: ApiService) {

  }

  ngOnInit() {



  }
}
